import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '@adsk/bim360-matrix-react-icon-button';
import Text from '@adsk/bim360-matrix-react-text';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import cancelInputRound from '@adsk/bim360-matrix-react-assets/cancel-input-round.svg';

import './_ListBox.scss';

/**
 * ListBox - a component that lets you show multiple values and allows removing each value.
 * Should be used when selection is done from outside of this component, and we want to allow value removal.
 */
class ListBox extends PureComponent {
  renderValue(value, index) {
    return (
      <div className="ListBox__value" key={index}>
        <Text className="ListBox__value-label" ellipsis>
          {value[this.props.labelKey]}
        </Text>
        <IconButton
          className="ListBox__value-remove-btn"
          onClick={() => this.props.onValueRemove(value)}
        >
          <SvgIcon>{cancelInputRound}</SvgIcon>
        </IconButton>
      </div>
    );
  }

  renderValues() {
    return (
      <div className="ListBox__values-container">
        {this.props.values.map((value, index) => this.renderValue(value, index))}
      </div>
    );
  }

  renderPlaceholder() {
    return <div className="ListBox__placeholder">{this.props.placeholder}</div>;
  }

  render() {
    const isEmpty = !this.props.values.length;
    const classes = classNames('ListBox', this.props.className, {
      'ListBox--empty': isEmpty
    });
    return (
      <div className={classes}>{isEmpty ? this.renderPlaceholder() : this.renderValues()}</div>
    );
  }
}

ListBox.defaultProps = {
  labelKey: 'label'
};

ListBox.propTypes = {
  /**
   * Class to add to the top level block
   */
  className: PropTypes.string,
  /**
   * Placeholder to be shown when empty
   */
  placeholder: PropTypes.node.isRequired,
  /**
   * Callback when clicking on a value remove button.
   */
  onValueRemove: PropTypes.func.isRequired,
  /**
   * Values to be shown. Values must be an immutable array as this component is `PureComponent`
   */
  values: PropTypes.arrayOf(PropTypes.any).isRequired,
  /**
   * Label key - the label to show for each value.
   */
  labelKey: PropTypes.string
};

export default ListBox;
